import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { ROLE, TOKEN } from '../../../_helpers/token';
import { baseURL } from '../../../_helpers';
import axios from 'axios';

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };
  componentDidMount() {
    axios.get(baseURL).then(res => { })

    if (TOKEN == null) {
      window.location.href = "/log_in";

    }
  }
  logout = () => {
    localStorage.removeItem('token');
  }
  render() {
    const { changeToLight, changeToDark } = this.props;

    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          <SidebarCategory title="Layout" icon="layers">
            <button className="sidebar__link" type="button" onClick={changeToLight}>
              <p className="sidebar__link-title">Light Theme</p>
            </button>
            <button className="sidebar__link" type="button" onClick={changeToDark}>
              <p className="sidebar__link-title">Dark Theme</p>
            </button>
          </SidebarCategory>
        </ul>
        <ul className="sidebar__block">
          {ROLE === '12' ?
            <>
              {/* <SidebarCategory title="LuckyNumber"
                icon="book">
                <SidebarLink
                  title="User Search"
                  route="/user_search"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Stats"
                  route="/players"
                  onClick={this.hideSidebar}
                /> */}
              {/* </SidebarCategory> */}
              <SidebarCategory title="Gaming Board Report" icon="briefcase">
                <SidebarLink title="Daily Deposits" route="/depositdaily_game" onClick={this.hideSidebar} />
                <SidebarLink title="Daily Withdrawal" route="/customers-withdrawals" onClick={this.hideSidebar} />
                <SidebarLink title="House Income Report" route="/houseincome" onClick={this.hideSidebar} />
                <SidebarLink
                  title="Daily Customers"
                  route="/customers"
                  onClick={this.hideSidebar}
                />


                <SidebarLink title="NetCashFlow" route="/netcashflow" onClick={this.hideSidebar} />

              </SidebarCategory>
            </> : null}

          {ROLE === '7' || ROLE === '8' ?
            <>

              <SidebarCategory title="SuperSorte"
                icon="book">
                <SidebarLink
                  title="User Search"
                  route="/user_search"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Stats"
                  route="/players"
                  onClick={this.hideSidebar}
                />
              </SidebarCategory>
              <SidebarCategory title="Today Management" icon="book">

                <SidebarLink title="Gaming Income" route="/gamingincome" onClick={this.hideSidebar} />

                <SidebarLink title="JackPot Winners" route="/jackpot" onClick={this.hideSidebar} />
                <SidebarLink title="JackPot Counts" route="/jackpotmonthly" onClick={this.hideSidebar} />
                <SidebarCategory title="Bets">
                  <SidebarLink title="Bets Per Day" route="/betsperday" onClick={this.hideSidebar} />
                  <SidebarLink title="Bets Per Hour" route="/betsperhour" onClick={this.hideSidebar} />
                  <SidebarLink title="Bets Per Type" route="/betstype" onClick={this.hideSidebar} />
                  {/* <SidebarLink title="Other Winners" route="/otherwinners" onClick={this.hideSidebar} /> */}
                  <SidebarLink title="Average Bets" route="/averagebets" onClick={this.hideSidebar} />
                </SidebarCategory>
              </SidebarCategory>

              <SidebarCategory title="Customers" icon="users">
                <SidebarLink title="Newly Recruited" route="/newlycustomer" onClick={this.hideSidebar} />
                <SidebarLink
                  title="Customers"
                  route="/customers"
                  onClick={this.hideSidebar}
                />






                <SidebarLink title="Incoming calls" route="/customerfeedback" onClick={this.hideSidebar} />

                <SidebarLink title="Out going calls" route="/outgoingcustomerfeedbacks" onClick={this.hideSidebar} />

                <SidebarLink title="Recruits vs Deposits" route="/newlyrecruitedcustomers" onClick={this.hideSidebar} />

                {/* <SidebarLink title="InActive Customers (Less than a month)" route="/inactivecustomers" onClick={this.hideSidebar} /> */}
                <SidebarLink title="InActive Customers" route="/inactivecustomersmonth" onClick={this.hideSidebar} />
                <SidebarLink title="Customer Recruitment" route="/customersubscription" onClick={this.hideSidebar} />

                <SidebarCategory title="Times Played">

                  <SidebarLink title="For Today" route="/threedayscustomers" onClick={this.hideSidebar} />

                  <SidebarLink title="Less than thrice for Yesterday" route="/yesterdaycustomers" onClick={this.hideSidebar} />

                  <SidebarLink title="Less than 4 times in a month" route="/playforthtimescustomers" onClick={this.hideSidebar} />

                  <SidebarLink title="Less than four times over a month" route="/playoveramonth" onClick={this.hideSidebar} />
                </SidebarCategory>
                {/* 

                <SidebarLink title="Other Winners" route="/otherwinners" onClick={this.hideSidebar} />
                <SidebarLink title="Average Bets" route="/socialmediaposts" onClick={this.hideSidebar} /> */}
              </SidebarCategory>


              <SidebarLink
                title="Social Media Posts"
                icon="file-add"
                route="/socialmediaposts"
                onClick={this.hideSidebar}
              />

              <SidebarLink
                title="Winners Full Info"
                icon="user"
                route="/customerfullinfo"
                onClick={this.hideSidebar}
              />




              <SidebarCategory title="Finance" icon="briefcase">
                <SidebarLink title="NetCashFlow" route="/netcashflow" onClick={this.hideSidebar} />

                <SidebarLink title="Mpesa Reversal" route="/reverse" onClick={this.hideSidebar} />

                <SidebarLink title="Award Winner" route="/award_winner" onClick={this.hideSidebar} />

                <SidebarLink title="House Income Report" route="/houseincome" onClick={this.hideSidebar} />
                <SidebarLink title="EWallet" route="/ewallet" onClick={this.hideSidebar} />
                <SidebarLink title="Wins vs Losses" route="/winloss" onClick={this.hideSidebar} />
                <SidebarLink title="Daily Deposits" route="/dailydeposit" onClick={this.hideSidebar} />
                <SidebarLink title="Daily Withdrawal" route="/customers-withdrawals" onClick={this.hideSidebar} />
                <SidebarLink title="Transactions Requests" route="/transaction" onClick={this.hideSidebar} />
                <SidebarLink title="Bet Type Distribution" route="/bettype" onClick={this.hideSidebar} />
              </SidebarCategory>

              <SidebarCategory title="Direct Cost Accounts" icon="briefcase">
                <SidebarLink title="Ground Activation Account" route="/groundcost" onClick={this.hideSidebar} />
                <SidebarLink title="Ggr Tax Account" route="/groundtax" onClick={this.hideSidebar} />
                <SidebarLink title="Reversed Sms Account" route="/smsreverse" onClick={this.hideSidebar} />
                <SidebarLink title="Sms Blast Account" route="/smsblasts" onClick={this.hideSidebar} />
                <SidebarLink title="Witholding Tax Account" route="/witholdtax" onClick={this.hideSidebar} />
              </SidebarCategory>

              <SidebarCategory title="Bets" icon="book">

                <SidebarLink title="Bets Per Day" route="/betsperday" onClick={this.hideSidebar} />
                <SidebarLink title="Bets Per Hour" route="/betsperhour" onClick={this.hideSidebar} />

                <SidebarLink title="Bets Per Type" route="/betstype" onClick={this.hideSidebar} />
                <SidebarLink title="JackPot" route="/jackpot" onClick={this.hideSidebar} />
                <SidebarLink title="JackPot Per Day" route="/jackpotcount" onClick={this.hideSidebar} />

                <SidebarLink title="Other Winners" route="/otherwinners" onClick={this.hideSidebar} />
                <SidebarLink title="Average Bets" route="/averagebets" onClick={this.hideSidebar} />

                <SidebarLink title="Daily Bets" route="/dailybets" onClick={this.hideSidebar} />
                <SidebarLink title="Total Bets" route="/dailybetscount" onClick={this.hideSidebar} />
              </SidebarCategory>
              <SidebarCategory title="Report" icon="book">
                <SidebarLink title="MO" route="/mo" onClick={this.hideSidebar} />

                <SidebarLink title="Summary" route="/summary" onClick={this.hideSidebar} />
                <SidebarLink title="EOD" route="/eod" onClick={this.hideSidebar} />
              </SidebarCategory>
              <SidebarCategory title="Mpesa Reconciliation" icon="briefcase">
                <SidebarLink title="Mpesa Reconciliation" route="/reconciledeposits" onClick={this.hideSidebar} />
              </SidebarCategory>
              <SidebarLink
                title="User Search"
                icon="user"
                route="/user"
                onClick={this.hideSidebar}
              />
              <SidebarLink title="Blacklist" route="/blacklist" icon="users" onClick={this.hideSidebar} />
              <SidebarCategory title="Blasts" icon="phone">


                <SidebarLink title="Recruitment" route="/recruitment" onClick={this.hideSidebar} />

                <SidebarLink title="Send Blast Last Active" route="/blasts" onClick={this.hideSidebar} />
                <SidebarLink title="Joining Date" route="/sms_created" onClick={this.hideSidebar} />

                <SidebarLink title="Active Depositors" route="/active_blasts" onClick={this.hideSidebar} />


                <SidebarLink title="Blast Never Deposited" route="/never_deposited" onClick={this.hideSidebar} />

                <SidebarLink title="Tickets" route="/tickets" onClick={this.hideSidebar} />


                <SidebarLink title="Balance Over 20" route="/send_balance" onClick={this.hideSidebar} />

                <SidebarLink title="Played counts" route="/blastcountplayed" onClick={this.hideSidebar} />



                <SidebarLink title="Queue Messages" route="/bulksms" onClick={this.hideSidebar} />
                <SidebarLink title="Blast Messages" route="/blasts_messages" onClick={this.hideSidebar} />

              </SidebarCategory>
            </> : null}

          {ROLE === '10' ?
            <>

              <SidebarCategory title="SuperSorte"
                icon="book">
                <SidebarLink
                  title="User Search"
                  route="/user_search"
                  onClick={this.hideSidebar}
                />
              </SidebarCategory>
              <SidebarLink
                title="User Search"
                icon="user"
                route="/user"
                onClick={this.hideSidebar}
              />
              <SidebarCategory title="Customers" icon="users">
                <SidebarLink title="Newly Recruited" route="/newlycustomer" onClick={this.hideSidebar} />
                <SidebarLink
                  title="Customers"
                  route="/customers"
                  onClick={this.hideSidebar}
                />



                <SidebarLink title="Active Customers" route="/activecustomers" onClick={this.hideSidebar} />
                <SidebarLink title="Recruits vs Deposits" route="/newlyrecruitedcustomers" onClick={this.hideSidebar} />

                {/* <SidebarLink title="InActive Customers (Less than a month)" route="/inactivecustomers" onClick={this.hideSidebar} /> */}
                <SidebarLink title="InActive Customers" route="/inactivecustomersmonth" onClick={this.hideSidebar} />
                <SidebarLink title="Customer Recruitment" route="/customersubscription" onClick={this.hideSidebar} />

                <SidebarCategory title="Times Played">

                  <SidebarLink title="For Today" route="/threedayscustomers" onClick={this.hideSidebar} />

                  <SidebarLink title="Less than thrice for Yesterday" route="/yesterdaycustomers" onClick={this.hideSidebar} />

                  <SidebarLink title="Less than 4 times in a month" route="/playforthtimescustomers" onClick={this.hideSidebar} />

                  <SidebarLink title="Less than four times over a month" route="/playoveramonth" onClick={this.hideSidebar} />
                </SidebarCategory>
                {/* 

                <SidebarLink title="Other Winners" route="/otherwinners" onClick={this.hideSidebar} />
                <SidebarLink title="Average Bets" route="/socialmediaposts" onClick={this.hideSidebar} /> */}
              </SidebarCategory>
              <SidebarLink title="Blacklist" route="/blacklist" icon="users" onClick={this.hideSidebar} />

              <SidebarLink title="Terms and Conditions" route="/termscon" icon="user" onClick={this.hideSidebar} />

            </> : null}
        </ul>
        <ul className="sidebar__block">
          <SidebarLink
            title="LogOut"
            route="/log_in"
            onClick={this.logout}
            icon="user"
          />
        </ul>

      </div>
    );
  }
}

export default SidebarContent;
